/**************************************************************************************************
//
//  Description: Maintenance page 
//
//  Copyright:    © 2020 - 2021 Aligned Assets Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//#region Version 1.0.0.0 changes
//    001   25.03.21 Peter Bryden               Initial Revision.
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
//#endregion */

/* #region imports */
import React, { useEffect, useState, useRef } from "react";
import PropTypes from 'prop-types';
import { DialogContent, DialogActions, Grid, Typography } from "@material-ui/core";

import { StreetListView } from "./../components/maintenancepage/streetListView"

import { useParams } from "react-router-dom";

import {
  GetStreetFromUSRN,
  GetSearchStreetURL,
  GetCanOperatorEditASDDataURL,
  GetClosedStreetsWithASDURL
} from '../configuration/AAConfig'


import authService from '../components/api-authorization/AuthorizeService';

import { ApplicationPaths } from '../components/api-authorization/ApiAuthorizationConstants';
import history from "../history";


/* #endregion imports */

const MaintenancePage = () => {

  const [loading, setLoading] = useState(false);

  const [apiURLs, setApiURLs] = useState(null);

  const [data, setData] = useState();
  const [closedUSRN, setClosedUSRN] = useState();

  const [open, setOpen] = useState(false);
  const [operatorId, setOperatorId] = React.useState();

  const getOperatorId = () => { return operatorId; }

  /*HANDLERS*/
  /* 
  const handleFormChangeOnMap = (typeName, pkId, isWholeRoad) => {

    const editStyle = { colour: [117, 112, 179], width: 5, style: "solid" };
    const asdHighlightStyle = { colour: [117, 112, 179], width: 5, style: "solid" };
    const esuHighlightStyle = { colour: [27, 158, 119], width: 5, style: "solid" };

    setCurrentForm(typeName);
    let highlightStyle = asdHighlightStyle;
    let graphicData = { dataIdx: -1, wktPaths: null, graphicStyle: highlightStyle, displayType: "WholeASD" };

    const SetupIdxAndWktData = (asdArray, pkId, isWholeRoad) => {
      const idx = asdArray ? asdArray.findIndex((elem) => elem.pkId == pkId) : -1;
      const wkt = (asdArray && idx >= 0 && !isWholeRoad) ? asdArray[idx].wktGeometry : wholeRoadWktGeometry();
      const display = (isWholeRoad) ? "WholeASD" : "PartASD";
      const style = (isWholeRoad) ? highlightStyle : editStyle;
      return { dataIdx: idx, wktPaths: wkt, displayType: display, graphicStyle: style };
    }

    if (data) {
      switch (typeName) {
        case "MaintenanceResponsibility":
          graphicData = SetupIdxAndWktData(asdData.maintenanceResponsibilities, pkId, isWholeRoad);
          break;
        case "ReinstatementCategory":
          graphicData = SetupIdxAndWktData(asdData.reinstatementCatergories, pkId, isWholeRoad);
          break;
        case "SpecialDesignation":
          graphicData = SetupIdxAndWktData(asdData.specialDesignations, pkId, isWholeRoad);
          break;
        case "Esu":
          graphicData.dataIdx = data.streetCrossRefs ? data.streetCrossRefs.findIndex((elem) => elem.esuId == pkId) : -1;
          graphicData.wktPaths = (data.streetCrossRefs && graphicData.dataIdx >= 0) ? data.streetCrossRefs[graphicData.dataIdx].esuNavigation.wktGeometry : null;
          graphicData.displayType = "ESU";
          highlightStyle = esuHighlightStyle;
          break;
      }
    }

    handleGraphicChange(graphicData.wktPaths, false);

    const highlightGraphic = { paths: (graphicData.graphicStyle === editStyle ? null : graphicData.wktPaths), colour: highlightStyle.colour, width: highlightStyle.width, style: highlightStyle.style, type: graphicData.displayType };
    const editGraphic = { paths: (graphicData.graphicStyle === editStyle ? graphicData.wktPaths : null), colour: editStyle.colour, width: editStyle.width, style: editStyle.style, type: graphicData.displayType };

    setOverlayGraphic({ highlightLayer: highlightGraphic, editLayer: editGraphic });
  }


  async function handleSaveASD(saveURL, saveMethod, savedASD, formName) {

    let validationErrors = [];
    const today = new Date();

    switch (formName) {
      case "MaintenanceResponsibility":
        if (!savedASD.streetStatus)
          validationErrors.push({ key: "streetStatus", error: "Street status is a required field." });
        break;

      case "ReinstatementCategory":
        if (!savedASD.streetReinstatementCategory && savedASD.streetReinstatementCategory !== 0)
          validationErrors.push({ key: "streetReinstatementCategory", error: "Category is a required field." });
        break;

      case "SpecialDesignation":
        if (!savedASD.specialDesignationCode)
          validationErrors.push({ key: "specialDesignationCode", error: "Designation is a required field." });
        break;
    }

    if (!savedASD.custodianCode)
      validationErrors.push({ key: "custodianCode", error: "Custodian is a required field." });

    switch (formName) {
      case "MaintenanceResponsibility":
        if (!savedASD.maintainingAuthorityCode)
          validationErrors.push({ key: "maintainingAuthorityCode", error: "Maintaining Authority is a required field." });
        break;

      case "ReinstatementCategory":
        if (!savedASD.reinstatementAuthorityCode)
          validationErrors.push({ key: "reinstatementAuthorityCode", error: "Reinstatement Authority is a required field." });
        break;

      case "SpecialDesignation":
        if (!savedASD.authorityCode)
          validationErrors.push({ key: "authorityCode", error: "Authority is a required field." });
        break;
    }

    if (!savedASD.startDate)
      validationErrors.push({ key: "startDate", error: "Start Date is a required field." });
    else if (savedASD.startDate > today)
      validationErrors.push({ key: "startDate", error: "Start Date cannot be in the future." });

    if (formName === "SpecialDesignation") {
      if (!savedASD.description || savedASD.description.length === 0)
        validationErrors.push({ key: "description", error: "Description is a required field." });
      else if (savedASD.description && savedASD.description.length > 255)
        validationErrors.push({ key: "description", error: "Maximum allowable number of characters is 255." });
    }

    if (savedASD.state === 2 && (!savedASD.endDate || moment(savedASD.endDate).format("YYYY MMMM DD") <= moment(savedASD.startDate).format("YYYY MMMM DD"))) {
      validationErrors.push({ key: "endDate", error: "When State is 2, then End Date must be present and greater than Start Date." });
    }

    if (!savedASD.wholeRoad) {
      if (!savedASD.specificLocation || savedASD.specificLocation.length === 0)
        validationErrors.push({ key: "specificLocation", error: "When WHOLE ROAD is false then Specific Location must not be null." });
      else if (savedASD.specificLocation && savedASD.specificLocation.length > 250)
        validationErrors.push({ key: "specificLocation", error: "Maximum allowable number of characters is 250." });
    }

    const wholeWkt = wholeAsdWkt();

    if ((!savedASD.wholeRoad && (!asdGeometry.current.includes("LINESTRING") || !asdGeometry.current.includes(","))) || (savedASD.wholeRoad && !wholeWkt))
      validationErrors.push({ key: "wholeRoad", error: "Geometry is a required field." });

    if (wholeWkt && !savedASD.wholeRoad && asdGeometry.current === wholeWkt)
      validationErrors.push({ key: "wholeRoad", error: "When WHOLE ROAD is false then the geometry must not be the same as the street geometry." });

    if (asdGeometryIntersects.current)
      validationErrors.push({ key: "wholeRoad", error: "The geometry intersects itself." });

    if (validationErrors.length === 0) {
      // If the record is marked as Whole Road ensure the geometry is the whole road as well.
      if (savedASD.wholeRoad)
        savedASD.wktGeometry = wholeWkt;
      else
        savedASD.wktGeometry = asdGeometry.current;
      const url = `${saveURL}/${getOperatorId()}`;
      const asdDataArray = [savedASD];
      const fetchData = JSON.stringify(asdDataArray);

      await fetch(url, {
        method: saveMethod,
        cache: 'no-cache',
        headers: { 'Content-Type': 'application/json' },
        body: fetchData
      })
        .then(res => (res.ok ? res : res.text().then(text => { throw new Error(text) })))
        .then(res => (saveMethod === "POST") ? res.json() : res)
        .then(
          (result) => {
            if (saveMethod === "POST")
              updateASDData(saveMethod, result[0], savedASD.pkId, currentform);
            else
              updateASDData(saveMethod, savedASD, savedASD.pkId, currentform);
          }
        )
        .catch(errorMessage => {
          validationErrors.push({ key: errorMessage.toString().includes("USRN when combined with CUSTODIAN_CODE and") ? "custodianCode" : "dbError", error: errorMessage.toString() });
          console.log("ERROR SaveForm", errorMessage, validationErrors);
        });
    }

    return validationErrors;
  }
  */

  /* HOOKS*/
  useEffect(() => {

    console.log("useEffect");

    async function populateOperator()  {
      const [authenticated] = await Promise.all([authService.isAuthenticated()])

      if (authenticated && operatorId == null) {
        const token = await authService.getAccessToken();
        const response = await fetch('user', {
          headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        }).then(res => (res.ok ? res : Promise.reject(res)))
          .then(res => res.json())
          .then(
            (result) => {
              console.log("populateOperator", result);
              if (result)
                setOperatorId(result.operatorid);
            },
            (error) => {
              console.log("Get operator Error", error);
              if (error.status === 401) {
                const logoutPath = { pathname: `${ApplicationPaths.LogOut}`, state: { local: true } };
                history.push(logoutPath);
              }
            }
          );
      }
    };

    const _subscription = authService.subscribe(() => populateOperator());

    async function SetUpApi() {
      console.log("SetupApi start");
      if (apiURLs == null) {
        const canEditUrl = await GetCanOperatorEditASDDataURL();
        const usrnUrl = await GetStreetFromUSRN();
        const searchUrl = await GetSearchStreetURL();
        const closedstreetsURL = await GetClosedStreetsWithASDURL();

        setApiURLs({ canEditASD: canEditUrl, usrnApiDetails: usrnUrl, SearchApiDetails: searchUrl, ClosedStreetsWithASD: closedstreetsURL });
      }
    }

    /*
    async function CanOperatorEditASD() {
      if (usrn && getOperatorId()) {
        if (apiURLs && apiURLs.canEditASD != null) {
          const canEditASD = apiURLs.canEditASD;
          console.log("fetching CanUserEditASDData", dataUsrn, `${canEditASD.url}/${getOperatorId()}/${usrn}`);
          fetch(`${canEditASD.url}/${getOperatorId()}/${usrn}`)
            .then(res => (res.ok ? res : Promise.reject(res)))
            .then(res => res.json())
            .then(
              (result) => {
                setAsdEditable(result);

              },
              // Note: it's important to handle errors here
              // instead of a catch() block so that we don't swallow
              // exceptions from actual bugs in components.
              (error) => {
                console.log("Cannot determine if user can edit ASD data = ", error);
              }
            );
        } else {
          console.log("canEditASD is null");
        }
      }
    }
    */

    async function SetUpClosedStreetData() {
      if (!data) {

        if (apiURLs && operatorId) {
          const closedStreets = apiURLs.ClosedStreetsWithASD;
          setLoading(true);
          fetch(`${closedStreets.url}\\${getOperatorId()}`)
            .then(res => (res.ok ? res : Promise.reject(res)))
            .then(res => res.json())
            .then(
              (result) => {
                setData(result);
              },
              // Note: it's important to handle errors here
              // instead of a catch() block so that we don't swallow
              // exceptions from actual bugs in components.
              (error) => {
                console.log("closed streets fetch error = ", error);
              }
            ).then(() => {
              setLoading(false);
            });
        }
      }
    }

    if (operatorId == null)
      populateOperator();

    if (apiURLs === null)
      SetUpApi();

    SetUpClosedStreetData();

    return () => {
      authService.unsubscribe(_subscription);
    };

  }, [operatorId, apiURLs]);

  const handleClick = (usrn) => {
    console.log("usrn selected ", usrn);
	}


  function ShowMaintenanceList() {
    return (
      <div className="maintenance-page"  >

        <Grid container justify="left" spacing={0.5}>
          <Grid item justify="inherit">
            <Grid container justify="inherit">
              <Typography variant="h6" paragraph="true" display="block" >Closed Streets With ASD</Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container justify="inherit">
              <Grid item xs={8} justify="inherit">
                <StreetListView streets={data} handleSelection={handleClick} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }

  function ShowASDList() {
    return (
      <div className="maintenance-page"  >

        <Grid container justify="left" spacing={0.5}>
          <Grid item justify="inherit">
            <Grid container justify="inherit">
              <Typography variant="h6" paragraph="true" display="block" >ASD List for {`${closedUSRN}`}</Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container justify="inherit">
              <Grid item xs={8} justify="inherit">
                ASD List Goes Here
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }

  if (data && !closedUSRN && !loading) {
    return ShowMaintenanceList();
  }
  else if (closedUSRN !== null)
  {
    return ShowASDList();
	}
  else
    return ( "Loading Maintenance Page" );
};

MaintenancePage.propTypes = {
  //classes: PropTypes.object.isRequired,
};

export default MaintenancePage;
